export const SET_STATUS = 'BEAMLY/CCX/MODAL_SET_STATUS';

export const setStatus = ({ id, status }) => ({ type: SET_STATUS, id, status });
